import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"

export const verifyAuthOtpEmailApi = createAsyncThunk(
    'auth/verify-auth-otp-email',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.post(`/api/v1/login/verify_otp/`, {
                user_type: "Dealor",
                type: 'email',
                otp: data?.otp
            })
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const verifyAuthOtpEmailSlice = createSlice({
    name: 'verify-auth-otp-email',
    initialState: { result: [], loading: false, error: null, message: "" },
    extraReducers: (builder) => {
        builder.addCase(verifyAuthOtpEmailApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(verifyAuthOtpEmailApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(verifyAuthOtpEmailApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const verifyAuthOtpEmailReducer = verifyAuthOtpEmailSlice.reducer